import APP_ASSETS from "@/assets";
import { useAllOrdersByMonthPooling } from "@/hooks/useAllOrdersPooling";
import { getVolume } from "@/utils/aggregate";
import { Link } from "react-router-dom";
import moment from "moment";
import { Skeleton } from "@/components/ui/skeleton";
import { useMerchant, useSmartWallet } from "@/contexts";

const Stats = () => {
  const { merchantDetails } = useMerchant();
  const { account } = useSmartWallet();

  const { segregatedOrders, loading } = useAllOrdersByMonthPooling(
    account?.address,
  );

  return (
    <main className="relative h-full max-h-[1200px] w-full max-w-[500px] bg-bg-tertiary">
      {/* ABSOLUTE POSITIONED TOPBAR */}
      <nav className="absolute top-0 flex h-14 w-full items-center justify-start gap-2 border-b border-primary bg-bg-tertiary p-4">
        <Link to={".."} relative="path">
          <img
            className="h-6 w-6"
            src={APP_ASSETS.ICONS.ARROW_LEFT}
            alt="img"
          />
        </Link>
        <p className="text-xl text-text-light">Stats</p>
      </nav>
      {/* ABSOLUTE POSITIONED TOPBAR */}
      {/* DISPUTES */}
      <section className="no-scrollbar flex h-full flex-col items-start overflow-y-scroll px-4 pt-16">
        {/* HEADER */}
        <div className="my-2 flex w-full flex-col items-start justify-between gap-4 rounded-lg border-[1px] border-stroke-primary px-6 py-4">
          <p className="text-text-primary">P2P.me balance in your account</p>
          <p className="text-lg font-bold text-text-light">
            {merchantDetails ? merchantDetails?.freeAmountFiat : "-"} INR
          </p>
        </div>
        {/* HEADER */}
        {/* VOLUME LIST */}
        <div className="flex w-full flex-col gap-2 py-4">
          <p className="text-text-primary">Monthly volume</p>
          <div className="flex w-full flex-col">
            {loading &&
              [1, 2, 3, 4, 5].map((_, i) => {
                return <Skeleton key={i} className="mt-1 h-[54px] w-full" />;
              })}
            {!loading &&
              Object.keys(segregatedOrders).map((key, i) => {
                return (
                  <div
                    key={i}
                    className="flex w-full items-center justify-between border-b border-stroke-primary py-2">
                    <p className="text-gray-300">
                      {moment(key).format("MMM YYYY")}
                    </p>
                    <p className="text-text-light">
                      {getVolume(segregatedOrders[key])} USDC
                    </p>
                  </div>
                );
              })}
          </div>
        </div>
        {/* VOLUME LIST */}
      </section>
      {/* DISPUTES */}
    </main>
  );
};

export default Stats;
